import { APP_PERMISSIONS } from '@exam-management/permissions';
import { QBankStructureProvider } from '@exam-management/qbs-provider';
import { useParams } from '@exam-management/router';
import { PermissionGuard } from '@shared/permissions';
import { Outlet } from 'react-router-dom';

export default function QBankStructureProviderLayout() {
  const { structureId } = useParams('/qbank-structures/:structureId');

  return (
    <PermissionGuard
      requiredPermission={[
        APP_PERMISSIONS.QBANK.STRUCTURE.VIEW,
        APP_PERMISSIONS.QBANK.AUDIT_LOG.VIEW,
        APP_PERMISSIONS.QBANK.DASHBOARD.VIEW,
        APP_PERMISSIONS.QBANK.LOS.VIEW,
        APP_PERMISSIONS.QBANK.QUESTION.VIEW,
        APP_PERMISSIONS.QBANK.SETTING.VIEW,
      ]}
      options={{ operator: 'OR' }}
    >
      <QBankStructureProvider qBankStructureId={structureId}>
        <Outlet />
      </QBankStructureProvider>
    </PermissionGuard>
  );
}
